export default "__VITE_ASSET__eb517b8e__"